export const CompanyName = ({name}) => {
  return <h2 className="company-name">{name}</h2>;
};
